import React, { Component } from "react";
import ArticleComments from "./ArticleComments"


class ArchonBomb extends Component {


  render() {
    var spacerStyle = {
      marginTop: "100px",

    }
    var cardGalleryStyle = {
      padding:20,
      backgroundColor: "white"
    }

    var imgCenterStyle = {
    display: "block",
    margin:"0 auto",
    marginBottom: 15
    }

    var imgLeftStyle = {
      display: "inline",
      margin:"5 auto",
      marginBottom: 15
    }

    var centerStyle = {
      justifyContent: "center",
      marginBottom: 15
    }

    var size13 = {
      fontSize: 13
    }
    var questionStyle ={
      fontSize:16,
      fontWeight:600
    }

    var answerStyle = {
      fontSize:16
    }

    return (

      <div className="container Site-content" id="cardGalleryWrapper" style={spacerStyle}>
        <div id="cardGallery" style={cardGalleryStyle} className="rounded">

          <h1>Deck Spotlight: Archon Bomb</h1>
          <p style={size13}>
            By: ISLIDrake - March 30, 2018
          </p>

          <img src={"../ArticleImages/Archon.jpg"} style={imgCenterStyle} className="img-fluid" id="grimm1" alt="grimm1" />

          <p style={answerStyle}>


            This is a deck inspired by a discussion in the Nova Blitz Telegram Channel. A question was asked about the interaction between Walking Bomb and Archon of Death.
            After testing I found out that the interaction is as follows:
            Archon of Death after triggering its last breath will deal damage equal to the strength Walking bomb had BEFORE dying.
            So if Walking Bomb died with 5 strength, Archon of Death will deal 5 damage (of course more bombs = more damage).
            This deck is about that. We try to burn our enemy by using Walking Bombs and Archon of Death to make it hard for enemy to calculate how much damage they will take.
          </p>
          <div className="row" style={centerStyle}>
            <div>
            <img src={"../Images200/101285.png"}  className="img-fluid" id="walkingbomb" alt="walkingbomb"  />
            </div>
            <div>
            <img src={"../Images200/101233.png"}  className="img-fluid" id="archonofdeath" alt="archonofdeath"  />
            </div>
          </div>
            <img src={"../ArticleImages/ArchonBomb.jpg"} style={imgCenterStyle} className="img-fluid" id="archonbomb" alt="archonbomb"  />
          <p style={questionStyle}>
            Card choices:
            </p><img src={"../Images200/101271.png"} style={imgLeftStyle} className="img-fluid" id="boomtinkerer" alt="boomtinkerer"  />
          <p style={answerStyle}>
             Boom Tinkerer:  Only one copy because I just cannot see myself playing more of this card. It is good that it cycles itself at least later in the game,
             but this deck is also more of a control deck, so your opponent will usually have enough removal to kill it the turn it comes on board.
          </p>  <img src={"../Images200/101034.png"} style={imgLeftStyle} className="img-fluid" id="finalblow" alt="finalblow"  />
          <p style={answerStyle}>

            Final Blow: A lot of synergy with Hellfire Cultists and other damaging cards. It is ok to play more of them if needed but for me 1 copy is enough.
            </p><img src={"../Images200/101045.png"} style={imgLeftStyle} className="img-fluid" id="hellfirecultist" alt="hellfirecultist"  />
            <img src={"../Images200/101137.png"} style={imgLeftStyle} className="img-fluid" id="sanctumhealer" alt="sanctumhealer"  />
<p style={answerStyle}>

            Hellfire Cultist and Sanctum Healer: These are auto includes in archon decks. Gives both board control and healing if needed.
            </p>  <img src={"../Images200/101245.png"} style={imgLeftStyle} className="img-fluid" id="mutate" alt="mutate"  />
<p style={answerStyle}>

            Mutate: Deck needs to draw a lot to get certain pieces in due time, also synergises well with walking bomb.
            </p>  <img src={"../Images200/101151.png"} style={imgLeftStyle} className="img-fluid" id="culltheweak" alt="culltheweak"  />
<p style={answerStyle}>

            Cull the Weak: This deck is not fast, so we take some early board clear for low cost board decks
            </p>    <img src={"../Images200/101270.png"} style={imgLeftStyle} className="img-fluid" id="timestop" alt="timestop"  />
<p style={answerStyle}>
            Time Stop: This is one of the strongest cards in the game, for 2 mana you can easily remove a lot of hit points from your opponent with a full board,
            also acts as a fog if we need it. Fog is an old Magic the Gathering card that prevented creatures from doing damage that turn.
            </p><img src={"../Images200/101191.png"} style={imgLeftStyle} className="img-fluid" id="weirdbolt" alt="weirdbolt"  />
            <p style={answerStyle}>

            Weirdbolt: This helps to burn your opponent and control the board at the same time.
            </p>  <img src={"../Images200/101233.png"} style={imgLeftStyle} className="img-fluid" id="archonofdeath" alt="archonofdeath"  />
            <p style={answerStyle}>
             Archon of Death: Core of the deck more on this card in the strategy section.
            </p>  <img src={"../Images200/101273.png"} style={imgLeftStyle} className="img-fluid" id="assembleranton" alt="assembleranton"  />
            <p style={answerStyle}>

            Assembler Anton: Very strong 3 drop, creating 2 bodies and giving us sweet construct synergy with Clockmaker Tox
            </p>  <img src={"../Images200/101265.png"} style={imgLeftStyle} className="img-fluid" id="clockmaker" alt="clockmaker"  />
            <p style={answerStyle}>

            Clockmaker Tox: Makes it easier to draw those Walking Bombs in time.
            </p>  <img src={"../Images200/101300.png"} style={imgLeftStyle} className="img-fluid" id="redeemer" alt="redeemer"  />
            <p style={answerStyle}>

            Redeemer: Repeatable purify and can control the board by itself, especially against those annoying nature decks.
            </p><img src={"../Images200/101285.png"} style={imgLeftStyle} className="img-fluid" id="walkingbomb2" alt="walkingbomb"  />
            <p style={answerStyle}>
            Walking Bomb: Core card, more on this in strategy.
            </p>  <img src={"../Images200/101237.png"} style={imgLeftStyle} className="img-fluid" id="judgement" alt="judgement"  />
            <p style={answerStyle}>

            Judgement: This is one for those big creatures.
            </p>
            <p style={questionStyle}>
            Strategy
            </p>
            <p style={answerStyle}>
            The deck tries to play as many Uniblasters and  Walking Bombs as possible
            before playing Archons of Death to trigger bombs and blasters from the graveyard for a lot of unexpected damage.
            </p>
            <p style={answerStyle}>
            Other cards help us get to high amount of mana to do that fast or help us find our constructs and archons faster.
            Cards like Cull the Weak and Holy Bolt (and also Teddy Bombs from Boom Tinkerer) can help us kill our own archons if we are
            afraid of cards like Betrayal, Mind Control or Purifies. I would describe this deck as "combo control."
            </p>
            <p style={questionStyle}>
            Mulligan :
            </p>
            <p style={answerStyle}>
            It is better to have some 1 drops and cyclers in your starting hand so cultists, healers and blasters are all good cards to keep.
            Same with Mutate and Purify. Archons of Death are not needed early in the game so we can mulligan them away.
            </p>
            <p style={questionStyle}>
            Early game :
            </p>
            <p style={answerStyle}>
            First turn if you have any just play your 1 drops.  We want them in the graveyard anyway later so no need to hold onto them.
            </p>
            <p style={answerStyle}>
            {" At 4 Mana you should know what you are playing against, so you need to play the game accordingly. Try to keep record of how much damage Archon of Death can deal (it's really hard as your learn to play the deck)."}
            </p>
            <p style={questionStyle}>
            Some Tips :
            </p>
            <p style={answerStyle}>
            {"Keep Archons of Death if you don't need to control the board. it is better to play them as late as possible, first you need to get your bombs and blasters in the graveyard."}
            </p>
            <p style={answerStyle}>
            If you play against hard control do not play out your hand without reason.
            Bait out removal on single threats and try to combo your cards together.
            </p>
            <p style={answerStyle}>
            Remember killing your own archon is also an option.
            </p>
            <p style={answerStyle}>
            Maximum damage with archon if all bombs got removed when they got played and uniblasters in graveyard is 18.
            If we add damage from their death it is already 36, nearly all of your opponents starting hit points.
            </p>
            <p style={answerStyle}>
            Do not be afraid of purify,
            it usually costs 2 mana which is a lot in first 5 turns. If you suspect your opponent has purify, keep your archons in your hand until you can instanly remove them.
            </p>
            <p style={answerStyle}>
            Do not worry about "combos", keeping Mutate for Walking Bomb when you are getting smashed by goblins will not help you in anyway.
            It is better to use 'drawing cards' to get through the deck quicker to find answers to current board states.
            Remember you have a lot of burn potential later in the game.
            </p>
            <p style={questionStyle}>
            Decks weaknesses:
            </p>
            <p style={answerStyle}> Armor: It negates Weirdbolt, and Cultist who form our base defense early on.
            </p>
            <p style={answerStyle}>
            Nature: right now too strong color,
            especially with cards like verdant druid and primal hunter.
            </p>
            <p style={answerStyle}>
            Healing: Since our win condition is burn,
            it is a lot harder to win if our enemy is constantly regaining lost hit points.
            </p>
            <p style={questionStyle}>
            Cards to Consider:
            </p>
            <p style={answerStyle}> Surprise attack: This could be an auto include, but i hate the card with a passion now and i just cannot push myself to play it.
            </p>
            <p style={answerStyle}>
            Rigged to Blow: A very good board clear but very hard to use together with Demonic Contract.
            </p>
            <p style={answerStyle}>
            Hellfire Storm: A good tool for defensive board decks, but kinda weak for its mana cost.
            </p>
            <p style={answerStyle}>
            Justice: You sometimes run your hand out of cards very quickly but justice is very hard to use effectively so i try to not play it.
            But its a very versatile cards and I will consider it in further testing
            </p>
            <p style={answerStyle}>
            Goblin Mechanics: personally for me is too slow but could be good.
            </p>
            <p style={answerStyle}>
            Eye Fiend: As the deck is archon of death based, killing our own creatures is usually fine,
            and this card is very scary when played on turn 3 (it even kills PRIMAL HUNTER !!!).
            </p>
            <p style={answerStyle}>
            Teddy Bomb, I Got a Rock, Bomb Juggler can be used if you want a more "aggro type approach."
            </p>
            <p style={questionStyle}>
            Summary:
            </p>
            <p style={answerStyle}>
            Overall the deck does decently well against control decks. With purify,
            lots of card draw and some removal we can remove the threats they create.
            The combo win condition lets us win by surprise. Aggro decks are as usual a pain, if you dont draw the answers at the right time.
            </p>
            <p style={answerStyle}>
            The best part of the deck is that it rarely has problems against opponents that hold their cards to avoid board clears.
            It has a lot of cheap cards that enable us to defend ourselves both in the early game and the late game.
          </p>
        </div>
          <ArticleComments articleId={"6"} />
      </div>


    );
  }
}

export default ArchonBomb;



// WEBPACK FOOTER //
// ./src/Articles/ArchonBomb.js